var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGratitudeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40000923_34533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09375 6.67871C5.1875 5.77246 5.1875 4.24121 6.09375 3.30371C7.03125 2.39746 8.5 2.39746 9.4375 3.30371L10 3.86621L10.5312 3.30371C11.4688 2.39746 12.9375 2.39746 13.875 3.30371C14.7812 4.24121 14.7812 5.77246 13.875 6.67871L10.6875 9.92871C10.5 10.1162 10.25 10.21 10 10.21C9.71875 10.21 9.46875 10.1162 9.28125 9.92871L6.09375 6.67871ZM18.75 12.9287C19.1562 13.4912 19.0312 14.2725 18.4688 14.6787L14.5312 17.585C13.7812 18.1162 12.9062 18.3975 12 18.3975H7H2C1.4375 18.3975 1 17.96 1 17.3975V15.3975C1 14.8662 1.4375 14.3975 2 14.3975H3.125L4.53125 13.2725C5.25 12.71 6.125 12.3975 7.03125 12.3975H9.5H10H12C12.5312 12.3975 13 12.8662 13 13.3975C13 13.96 12.5312 14.3975 12 14.3975H10H9.5C9.21875 14.3975 9 14.6475 9 14.8975C9 15.1787 9.21875 15.3975 9.5 15.3975H13.25L17 12.6475C17.5625 12.2412 18.3438 12.3662 18.75 12.9287ZM7.03125 14.3975H7C7.03125 14.3975 7.03125 14.3975 7.03125 14.3975Z",
    fill: "url(#paint0_linear_40000923_34533)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40000923_34533",
    x1: 10,
    y1: 0.397461,
    x2: 10,
    y2: 20.3975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4545"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40000923_34533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.397461)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGratitudeIcon);
export default __webpack_public_path__ + "static/media/gratitude-icon.7238178cc10b8dd1c534af2fb641eb51.svg";
export { ForwardRef as ReactComponent };